import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../resources/assets/images/kozeelogo.svg";
import "./Navbar.css";

import '../../resources/styling/GlobalStyles.css';

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
    setMenuOpen(false); // Close menu on mobile
  };

  return (
    <nav className="navbar-container">
      {/* Logo */}
      <div className="navbar-logo" onClick={() => navigate("/")}>
        <Logo className="logo" />
      </div>

      {/* Mobile Menu Toggle */}
      <button className="mobile-menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </button>

      {/* Main Nav List */}
      <ul className={`navbar-list ${menuOpen ? "open" : ""}`}>
        <li className="navbar-item">
          <button className="navbar-link" onClick={() => handleNavigation("/")}>
            Home
          </button>
        </li>

        <li className="navbar-item companies-dropdown">
          <button className="navbar-link">Products</button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="button-style dropdown-item"
                onClick={() => handleNavigation("/synergy")}
              >
                Synergy
              </button>
            </li>
          </ul>
        </li>

        <li className="navbar-item services-dropdown">
          <button className="navbar-link" >Services</button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="button-style dropdown-item"
                onClick={() => handleNavigation("/export")}
              >
                Export
              </button>
            </li>
          </ul>
        </li>

        <li className="navbar-item">
          <button className="navbar-link" onClick={() => handleNavigation("/about")}>
            About Us
          </button>
        </li>

        <li className="navbar-item">
          <button
            className="navbar-link" 
            onClick={() => handleNavigation("/contact")}
          >
            Contact Us
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
